import { render, staticRenderFns } from "./SettingSelection.vue?vue&type=template&id=67fae61e&scoped=true&"
import script from "./SettingSelection.vue?vue&type=script&lang=ts&"
export * from "./SettingSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fae61e",
  null
  
)

export default component.exports